module.exports = __webpack_public_path__ + "static/media/dash2.67cde94f.png";